import { WB_TPM_EventSpendPrdGrpRow, WB_TPM_EventSpendPrdRow, WB_TPM_EventSpendRow } from "../PA.Core/PAdbSchemaRows";
import { BehaviorSubject } from "rxjs";
import { IMessageProvider, IProgressProvider } from "../PA.Core/PA.Core.IF.Basic";
import { TPMEventBO } from "../PA.TPM.BusinessObjects/TPMEventBO";
import { IwbTPMEventSpend } from "../PA.Core/PAdbSchemaRowsIF";

export interface IHaveTPMEventSpend {
    addTPMEventSpend(wb_evtstype_id: number, opts: ITPMEventSpendAddOptions): Promise<ITPMEventSpend>;
    removeTPMEventSpend(wb_evts_id: number | number[], options: any): Promise<void>;
    canRemoveTPMEventSpend(wb_evts_id: number): boolean;

    readonly TPMEventSpends: ITPMEventSpend[];
    readonly TPMEventSpendCollectionChanged: BehaviorSubject<IHaveTPMEventSpend>;
}

export interface ITPMEventSpendAddOptions {
    InitialValues?: IwbTPMEventSpend;
    SkipCalculatorRefresh?: boolean;
}

export const ITPMEventSpendAddOptionsDefaults: ITPMEventSpendAddOptions = {
    InitialValues: {},
};

export interface ITPMEventSpend {
    readonly OnLoadComplete: Promise<void>;
    readonly bIsLoaded: boolean;

    readonly WB_EvtS_ID: number;
    readonly TPMEventSpendRow: WB_TPM_EventSpendRow;
    readonly TPMEventBO: TPMEventBO;

    readonly TPMEventSpendPropertyChanged: BehaviorSubject<ITPMEventSpendChangedEvent>;

    readonly isActive: boolean;
    readonly bCanDelete: boolean;
    markDeleted(): void;

    Validate(options?: any): Promise<void>;
    readonly ValidateMessageProvider: IMessageProvider;

    ValidateBeforeDelete(options?: any): Promise<void>;
    readonly DeleteMessageProvider: IMessageProvider;
}

export interface ITPMEventSpendChangedEvent {
    TPMEventSpend: ITPMEventSpend;
    Row: WB_TPM_EventSpendRow;
    PropertyChanged: string;
    PropertyValue: any;
}

export interface ITPMEventSpendProductGroupChangedEvent {
    TPMEventSpend: ITPMEventSpend;
    Row: WB_TPM_EventSpendPrdGrpRow;
    PropertyChanged: string;
    PropertyValue: any;
}

export interface ITPMEventSpendProductGroupsAddOptions {
    bInclude?: boolean;
}

export interface ITPMEventSpendProductGroups {
    addTPMEventSpendProductGroup(
        wb_prdgrp_id: number | number[],
        options: ITPMEventSpendProductGroupsAddOptions,
    ): Promise<WB_TPM_EventSpendPrdGrpRow[]>;

    removeTPMEventSpendProductGroupRow(wb_tevtspg_id: number | number[], options: any): Promise<void>;
    canRemoveTPMEventSpendProductGroupRow(wb_tevtspg_id: number): boolean;

    readonly TPMEventSpendProductGroupCollectionChanged: BehaviorSubject<ITPMEventSpendProductGroups>;

    readonly TPMEventSpendProductGroupPropertyChanged: BehaviorSubject<ITPMEventSpendProductGroupChangedEvent>;
}

export interface ITPMEventSpendProductChangedEvent {
    TPMEventSpend: ITPMEventSpend;
    Row: WB_TPM_EventSpendPrdRow;
    PropertyChanged: string;
    PropertyValue: any;
}

export interface ITPMEventSpendProductsAddOptions {
    RowType?: string; // Don't specify unless you want to override
    ParentRowId?: number;
    bInclude?: boolean;
}

export const ITPMEventSpendProductsAddOptionsDefaults: ITPMEventSpendProductsAddOptions = {};

export interface ITPMEventSpendProducts {
    addTPMEventSpendProduct(
        wb_prod_id: number | number[],
        options: ITPMEventSpendProductsAddOptions,
    ): Promise<WB_TPM_EventSpendPrdRow[]>;

    removeTPMEventSpendProductRow(wb_tevtsprd_id: number | number[]): Promise<void>;
    canRemoveTPMEventSpendProductRow(wb_tevtsprd_id: number): boolean;

    readonly TPMEventSpendProductCollectionChanged: BehaviorSubject<ITPMEventSpendProducts>;

    readonly TPMEventSpendProductPropertyChanged: BehaviorSubject<ITPMEventSpendProductChangedEvent>;
}
